// src/constants.ts
var DEFAULT_BACKEND_URL = "https://identityconnect.com";

// src/network.ts
var NetworkName = /* @__PURE__ */ ((NetworkName2) => {
  NetworkName2["DEVNET"] = "devnet";
  NetworkName2["MAINNET"] = "mainnet";
  NetworkName2["TESTNET"] = "testnet";
  return NetworkName2;
})(NetworkName || {});

// src/types/pairing.ts
var PairingStatus = /* @__PURE__ */ ((PairingStatus2) => {
  PairingStatus2["Finalized"] = "FINALIZED";
  PairingStatus2["Pending"] = "PENDING";
  return PairingStatus2;
})(PairingStatus || {});

// src/types/signingRequest.ts
var SigningRequestTypes = /* @__PURE__ */ ((SigningRequestTypes2) => {
  SigningRequestTypes2["SIGN_AND_SUBMIT_TRANSACTION"] = "SIGN_AND_SUBMIT_TRANSACTION";
  SigningRequestTypes2["SIGN_MESSAGE"] = "SIGN_MESSAGE";
  SigningRequestTypes2["SIGN_TRANSACTION"] = "SIGN_TRANSACTION";
  return SigningRequestTypes2;
})(SigningRequestTypes || {});
var SigningRequestStatus = /* @__PURE__ */ ((SigningRequestStatus2) => {
  SigningRequestStatus2["APPROVED"] = "APPROVED";
  SigningRequestStatus2["CANCELLED"] = "CANCELLED";
  SigningRequestStatus2["INVALID"] = "INVALID";
  SigningRequestStatus2["PENDING"] = "PENDING";
  SigningRequestStatus2["REJECTED"] = "REJECTED";
  return SigningRequestStatus2;
})(SigningRequestStatus || {});
export {
  DEFAULT_BACKEND_URL,
  NetworkName,
  PairingStatus,
  SigningRequestStatus,
  SigningRequestTypes
};
//# sourceMappingURL=index.mjs.map